import styled, { css } from 'styled-components';
import SVG from '../../SVG';

export const CardToolsColumn = styled.div`
  ${() => css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100vh / 3 - 100px);
    min-width: 180px;
    aspect-ratio: 1;
    background: #d9d9d9;
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
    transition:
      transform 0.3s,
      box-shadow 0.3s;
    transform-origin: center;
    &:hover {
      transform: translateY(5px);
      box-shadow: 10 4px 8px rgba(0, 0, 0, 0.2);
    }
  `}
`;

export const TitleTolls = styled.label`
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 100;
  width: 150px;
  color: #364856;
  font-size: 26px;
  margin-top: 20px;
  cursor: pointer;
`;
export const CardToolsImagem = styled.img`
  height: 67px;
  width: 57px;
  margin-right: 10px;
  margin-left: 10px;
  background-repeat: repeat;
  margin-top: 30px;
`;

export const CadeadoImagem = styled.img`
  width: 18px;
  height: 18px;
  padding-right: 22px;
`;

export const CaixaLinhaCadeado = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`;

export const CardLock = styled(SVG.Icon.Lock)`
  position: absolute;
  top: 10px;
  right: 10px;
`;
